import React from "react";
import { FaBookOpen, FaVideo, FaMicrophone, FaGraduationCap } from "react-icons/fa";
import "./WhatWeDoSection.css";

import sectionBg from "../../Assets/images/boardroom.jpeg"; 

const platforms = [
  {
    name: "Publishing",
    icon: <FaBookOpen />,
    tagline: "Turn ideas into books and thought leadership.",
    forWhom: "For: students, parents, entrepreneurs, educators, leaders",
    includes: "Includes: book development, publishing, distribution",
    outcome: "Outcome: authority, credibility"
  },
  { 
    name: "Productions",
    icon: <FaVideo />,
    tagline: "Turn ideas into media and audience growth.",
    forWhom: "For: brands, creators, leaders",
    includes: "Includes: podcasts, film, digital series",
    outcome: "Outcome: visibility, storytelling"
  },
  {
    name: "Events",
    icon: <FaMicrophone />,
    tagline: "Turn ideas into live experiences.",
    forWhom: "For: students, institutions, communities",
    includes: "Includes: workshops, retreats, conferences",
    outcome: "Outcome: engagement, real-world impact"
  },
  {
    name: "Academy",
    icon: <FaGraduationCap />,
    tagline: "Turn ideas into structured learning.",
    forWhom: "For: students, parents, teachers",
    includes: "Includes: courses, mentoring, coaching",
    outcome: "Outcome: growth, leadership"
  },
];

const WhatWeDoSection = () => {
  return (
    <section
      className="what-we-do-section"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.75)), url(${sectionBg})`
      }}
    >
      <div className="section-header">
        <h2>How AMPLE HOUSE Builds Leaders</h2>
        <p>Four integrated platforms. One leadership ecosystem.</p>
      </div>

      <div className="platforms-grid">
        {platforms.map((platform, idx) => (
          <div className="platform-card" key={idx}>
            
            <div className="card-top">
              <div className="platform-icon">{platform.icon}</div>
              <h3 className="platform-name">{platform.name}</h3>
            </div>

            <div className="card-body">
              <p className="platform-tagline">{platform.tagline}</p>
              <p className="platform-detail">{platform.forWhom}</p>
              <p className="platform-detail">{platform.includes}</p>
              <p className="platform-detail">{platform.outcome}</p>
            </div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default WhatWeDoSection;